<template>
  <!-- <base-auto-complete
    v-model="defaults.asset_account"
    :suggestions="filteredList"
    :name="name"
    @auto-complete="searchList($event)"
    field="display_name"
    @btn-create="createNew(slotProps.data.EntityType)"
    :input-attrs="inputAttrs"
  /> -->
  {{ inputAttrs }}=={{ name }}=={{ field }}
</template>
<script>
export default {
  props: {
    value: null,
    inputAttrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
    name: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
